import { render } from "./NavigationItem.vue?vue&type=template&id=697326de&scoped=true&ts=true"
import script from "./NavigationItem.vue?vue&type=script&lang=ts"
export * from "./NavigationItem.vue?vue&type=script&lang=ts"

import "./NavigationItem.vue?vue&type=style&index=0&id=697326de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697326de"]])

export default __exports__